import {
    INCO_TERMS_LIST,
    COUNTRY_LIST,
    UOM_TYPE_LIST,
    SALES_PERSON_LIST,
    DOCUMENT_TYPE_PURCHASE_LIST,
    DOCUMENT_TYPE_SALES_LIST,
    QUANTITY_TYPE_LIST,
    COMMODITYGROUP,
    CONTAINER_TYPE_LIST,
    OPERATOR_LIST,
    MOVE_TYPE,
    CURRENCY_LIST,
    CHARGE_BASIS_LIST,
    UOM_LIST,
    FILE_MANAGER_LIST,
    COMPANY_USER_LIST,
    MASTER_COMPANY_DETAIL,
    STANDARD_TERMS_LIST,
    CHARGES_DESCRIPTION_LIST,
    ACCOUNT_ADDRESSBOOK_MODULE_LIST,
    ACCOUNT_ADDRESSBOOK_BASIS_LIST,
    CARRIER_LIST,
    OFFICE_TYPE,
    PROFIT_CENTER,
    PACKAGE_TYPE,
    MANUFACTURER_LIST,
    NOTES_TYPE,
    BL_TYPE_LIST,
    CLOADER_LIST,
    ROLE_LIST,
} from "./constant";
import { APICall } from "@/config/NetworkUtility";
import { setAuthToken } from "@/utility/CommonConstant";

/**
 *
 * @param {*} payload
 * @returns
 */
export const getIncoTermsList = () => {
    return (dispatch) => {
        const url = `v1/Common/GetIncoTerms`;
        return APICall("get", {}, url).then(
            (result) => {
                if (result?.statuscode === 200 || result?.statuscode === 201) {
                    dispatch({
                        type: INCO_TERMS_LIST,
                        payload: result?.data || [],
                    });
                    return result?.data;
                } else {
                    return Promise.reject();
                }
            },
            (error) => {
                return Promise.reject(error);
            },
        );
    };
};

export const getCountryList = () => {
    return (dispatch) => {
        const url = `v1/Common/GetCountry`;
        return APICall("get", {}, url).then(
            (result) => {
                if (result?.statuscode === 200 || result?.statuscode === 201) {
                    dispatch({
                        type: COUNTRY_LIST,
                        payload: result?.data || [],
                    });
                    return result?.data;
                } else {
                    return Promise.reject();
                }
            },
            (error) => {
                return Promise.reject(error);
            },
        );
    };
};

export const getUomTypeList = () => {
    return (dispatch) => {
        const url = `v1/Common/GetUomType`;
        return APICall("get", {}, url).then(
            (result) => {
                if (result?.statuscode === 200 || result?.statuscode === 201) {
                    dispatch({
                        type: UOM_TYPE_LIST,
                        payload: result?.data || [],
                    });
                    return result?.data;
                } else {
                    return Promise.reject();
                }
            },
            (error) => {
                return Promise.reject(error);
            },
        );
    };
};

export const getSalesPersonList = () => {
    return (dispatch) => {
        const url = `v1/Common/GetSalesPerson`;
        return APICall("get", {}, url).then(
            (result) => {
                if (result?.statuscode === 200 || result?.statuscode === 201) {
                    dispatch({
                        type: SALES_PERSON_LIST,
                        payload: result?.data || [],
                    });
                    return result?.data;
                } else {
                    return Promise.reject();
                }
            },
            (error) => {
                return Promise.reject(error);
            },
        );
    };
};

export const getDocumentTypePurchaseList = () => {
    return (dispatch) => {
        const url = `v1/Common/GetDocumentType?DocType=PO`;
        return APICall("get", {}, url).then(
            (result) => {
                if (result?.statuscode === 200 || result?.statuscode === 201) {
                    dispatch({
                        type: DOCUMENT_TYPE_PURCHASE_LIST,
                        payload: result?.data || [],
                    });
                    return result?.data;
                } else {
                    return Promise.reject();
                }
            },
            (error) => {
                return Promise.reject(error);
            },
        );
    };
};

export const getDocumentTypeSalesList = () => {
    return (dispatch) => {
        const url = `v1/Common/GetDocumentType?DocType=SO`;
        return APICall("get", {}, url).then(
            (result) => {
                if (result?.statuscode === 200 || result?.statuscode === 201) {
                    dispatch({
                        type: DOCUMENT_TYPE_SALES_LIST,
                        payload: result?.data || [],
                    });
                    return result?.data;
                } else {
                    return Promise.reject();
                }
            },
            (error) => {
                return Promise.reject(error);
            },
        );
    };
};

export const getQuantityTypeList = () => {
    return (dispatch) => {
        const url = `v1/Common/GetQuantityType`;
        return APICall("get", {}, url).then(
            (result) => {
                if (result?.statuscode === 200 || result?.statuscode === 201) {
                    dispatch({
                        type: QUANTITY_TYPE_LIST,
                        payload: result?.data || [],
                    });
                    return result?.data;
                } else {
                    return Promise.reject();
                }
            },
            (error) => {
                return Promise.reject(error);
            },
        );
    };
};

export const getCommodityGroup = () => {
    return (dispatch) => {
        const url = `v1/Common/GetCommodityGroup`;
        return APICall("get", {}, url).then(
            (result) => {
                if (result?.statuscode === 200 || result?.statuscode === 201) {
                    dispatch({
                        type: COMMODITYGROUP,
                        payload: result?.data || [],
                    });
                    return result?.data;
                } else {
                    return Promise.reject();
                }
            },
            (error) => {
                return Promise.reject(error);
            },
        );
    };
};

export const getContainerType = () => {
    return (dispatch) => {
        const url = `v1/Common/GetContainerType`;
        return APICall("get", {}, url).then(
            (result) => {
                if (result?.statuscode === 200 || result?.statuscode === 201) {
                    dispatch({
                        type: CONTAINER_TYPE_LIST,
                        payload: result?.data || [],
                    });
                    return result?.data;
                } else {
                    return Promise.reject();
                }
            },
            (error) => {
                return Promise.reject(error);
            },
        );
    };
};

export const GetOperator = () => {
    return (dispatch) => {
        const url = `v1/Common/GetOperator`;
        return APICall("get", {}, url).then(
            (result) => {
                if (result?.statuscode === 200 || result?.statuscode === 201) {
                    dispatch({
                        type: OPERATOR_LIST,
                        payload: result?.data || [],
                    });
                    return result?.data;
                } else {
                    return Promise.reject();
                }
            },
            (error) => {
                return Promise.reject(error);
            },
        );
    };
};

export const getMoveType = () => {
    return (dispatch) => {
        const url = `v1/Common/GetMoveType`;
        return APICall("get", {}, url).then(
            (result) => {
                if (result?.statuscode === 200 || result?.statuscode === 201) {
                    dispatch({
                        type: MOVE_TYPE,
                        payload: result?.data || [],
                    });
                    return result?.data;
                } else {
                    return Promise.reject();
                }
            },
            (error) => {
                return Promise.reject(error);
            },
        );
    };
};

export const getClauselist = (payload) => {
    return (dispatch) => {
        const queryParams = new URLSearchParams({
            ...payload,
        }).toString();
        const url = `v1/Common/GetClauseList?${queryParams}`;
        return APICall("get", {}, url).then(
            (result) => {
                if (result?.statuscode === 200 || result?.statuscode === 201) {
                    return result?.data;
                } else {
                    return Promise.reject();
                }
            },
            (error) => {
                return Promise.reject(error);
            },
        );
    };
};

export const GetCurrencyList = () => {
    return (dispatch) => {
        const url = `v1/Common/GetCurrencyList`;
        return APICall("get", {}, url).then(
            (result) => {
                if (result?.statuscode === 200 || result?.statuscode === 201) {
                    dispatch({
                        type: CURRENCY_LIST,
                        payload: result?.data || [],
                    });
                    return result?.data;
                } else {
                    return Promise.reject();
                }
            },
            (error) => {
                return Promise.reject(error);
            },
        );
    };
};

export const GetChargeBasisList = () => {
    return (dispatch) => {
        const url = `v1/Common/GetChargeBasisList`;
        return APICall("get", {}, url).then(
            (result) => {
                if (result?.statuscode === 200 || result?.statuscode === 201) {
                    dispatch({
                        type: CHARGE_BASIS_LIST,
                        payload: result?.data || [],
                    });
                    return result?.data;
                } else {
                    return Promise.reject();
                }
            },
            (error) => {
                return Promise.reject(error);
            },
        );
    };
};

export const getUomList = () => {
    return (dispatch) => {
        const url = `v1/Common/GetPrimaryUomList`;
        return APICall("get", {}, url).then(
            (result) => {
                if (result?.statuscode === 200 || result?.statuscode === 201) {
                    dispatch({
                        type: UOM_LIST,
                        payload: result?.data || [],
                    });
                    return result?.data;
                } else {
                    return Promise.reject();
                }
            },
            (error) => {
                return Promise.reject(error);
            },
        );
    };
};

export const getFileManagerList = () => {
    return (dispatch) => {
        const url = `v1/Common/GetFileManagerList`;
        return APICall("get", {}, url).then(
            (result) => {
                if (result?.statuscode === 200 || result?.statuscode === 201) {
                    dispatch({
                        type: FILE_MANAGER_LIST,
                        payload: result?.data || [],
                    });
                    return result?.data;
                } else {
                    return Promise.reject();
                }
            },
            (error) => {
                return Promise.reject(error);
            },
        );
    };
};

export const getCompanyUserList = (CompanyId = 0) => {
    return (dispatch) => {
        const url = `v1/Common/GetCompanyUser?CompanyId=${CompanyId ?? 0}`;
        return APICall("get", {}, url).then(
            (result) => {
                if (result?.statuscode === 200 || result?.statuscode === 201) {
                    dispatch({
                        type: COMPANY_USER_LIST,
                        payload: result?.data || [],
                    });
                    return result?.data;
                } else {
                    return Promise.reject();
                }
            },
            (error) => {
                return Promise.reject(error);
            },
        );
    };
};

export const getMasterCompanyDetails = (para) => {
    return (dispatch) => {
        const url = `/MasterCompanyDetails/MasterCompanyDetails?MasterCompanyId=${para}`;
        return APICall("get", {}, url).then(
            (result) => {
                if (result?.statuscode === 200 || result?.statuscode === 201) {
                    localStorage.setItem(
                        "MasterCompanyDetails",
                        JSON.stringify(result?.data),
                    );
                    dispatch({
                        type: MASTER_COMPANY_DETAIL,
                        payload: result?.data || [],
                    });
                    return result?.data;
                } else {
                    return Promise.reject();
                }
            },
            (error) => {
                return Promise.reject(error);
            },
        );
    };
};

export const getCustomerandVendorPaymentList = () => {
    return (dispatch) => {
        const url = `v1/Common/GetStandardTermsList`;
        return APICall("get", {}, url).then(
            (result) => {
                if (result?.statuscode === 200 || result?.statuscode === 201) {
                    dispatch({
                        type: STANDARD_TERMS_LIST,
                        payload: result?.data || [],
                    });
                    return result?.data;
                } else {
                    return Promise.reject();
                }
            },
            (error) => {
                return Promise.reject(error);
            },
        );
    };
};

export const getAccounChargesList = (searchKeyword) => {
    return (dispatch) => {
        const url = `v1/Common/ChargesDescription_List?searchKeyword=${encodeURIComponent(searchKeyword)}`;
        return APICall("get", {}, url).then(
            (result) => {
                if (result?.statuscode === 200 || result?.statuscode === 201) {
                    dispatch({
                        type: CHARGES_DESCRIPTION_LIST,
                        payload: result?.data || [],
                    });
                    return result?.data; // <-- This is correct
                } else {
                    return Promise.reject();
                }
            },
            (error) => Promise.reject(error),
        );
    };
};

export const GetAddressBookAccountVendorDetails = (searchKeyword) => {
    return (dispatch) => {
        const url = `v1/Common/GetAddressBookAccountVendorDetails?searchKeyword=${encodeURIComponent(searchKeyword)}`;
        return APICall("get", {}, url).then(
            (result) => {
                if (result?.statuscode === 200 || result?.statuscode === 201) {
                    dispatch({
                        type: CHARGES_DESCRIPTION_LIST,
                        payload: result?.data || [],
                    });
                    return result?.data; // <-- This is correct
                } else {
                    return Promise.reject();
                }
            },
            (error) => Promise.reject(error),
        );
    };
};

export const GetAccountAdressbookModuleList = () => {
    return (dispatch) => {
        const url = `v1/Common/GetAccountAdressModuleList`;
        return APICall("get", {}, url).then(
            (result) => {
                if (result?.statuscode === 200 || result?.statuscode === 201) {
                    dispatch({
                        type: ACCOUNT_ADDRESSBOOK_MODULE_LIST,
                        payload: result?.data || [],
                    });
                    return result?.data;
                } else {
                    return Promise.reject();
                }
            },
            (error) => {
                return Promise.reject(error);
            },
        );
    };
};

export const GetAccountAdressbookBasisList = () => {
    return (dispatch) => {
        const url = `v1/Common/GetAccountAdressBasisList`;
        return APICall("get", {}, url).then(
            (result) => {
                if (result?.statuscode === 200 || result?.statuscode === 201) {
                    dispatch({
                        type: ACCOUNT_ADDRESSBOOK_BASIS_LIST,
                        payload: result?.data || [],
                    });
                    return result?.data;
                } else {
                    return Promise.reject();
                }
            },
            (error) => {
                return Promise.reject(error);
            },
        );
    };
};

export const SendEmail = async (payload) => {
    try {
        const url = `v1/SendEmail/SendEmail`;
        return APICall("post", payload, url).then(
            (result) => {
                if (result?.statuscode === 200 || result?.statuscode === 201) {
                    return result?.data;
                } else {
                    return Promise.reject();
                }
            },
            (error) => {
                return Promise.reject(error);
            },
        );
    } catch (error) {
        return Promise.reject(error);
    }
};

export const GetCarrierList = () => {
    return (dispatch) => {
        const url = `v1/Common/GetCarrierList`;
        return APICall("get", {}, url).then(
            (result) => {
                if (result?.statuscode === 200 || result?.statuscode === 201) {
                    dispatch({
                        type: CARRIER_LIST,
                        payload: result?.data || [],
                    });
                    return result?.data;
                } else {
                    return Promise.reject();
                }
            },
            (error) => {
                return Promise.reject(error);
            },
        );
    };
};

export const GetUnLocationByISOCodeList = (CountryCode) => {
    const url = `V1/Common/GetUnLocationByISOCodeList?CountryCode=${CountryCode}`;
    return APICall("get", {}, url).then(
        (result) => {
            if (result?.statuscode === 200 || result?.statuscode === 201) {
                return result?.data;
            } else {
                return Promise.reject();
            }
        },
        (error) => {
            return Promise.reject(error);
        },
    );
};
export const GetCountryStateList = (CountryCode) => {
    const url = `v1/Common/GetCountryStateList?CountryCode=${CountryCode}`;
    return APICall("get", {}, url).then(
        (result) => {
            if (result?.statuscode === 200 || result?.statuscode === 201) {
                return result?.data;
            } else {
                return Promise.reject();
            }
        },
        (error) => {
            return Promise.reject(error);
        },
    );
};
export const GetAccountAddressList = (id = 0) => {
    const url = `/v1/Common/GetAccountAddressList?AddressId=${id}`;
    return APICall("get", {}, url).then(
        (result) => {
            if (result?.statuscode === 200 || result?.statuscode === 201) {
                return result?.data;
            } else {
                return Promise.reject();
            }
        },
        (error) => {
            return Promise.reject(error);
        },
    );
};

export const GetOfficeTypeList = (CompanyId) => {
    return (dispatch) => {
        const url = `/v1/Common/GetOfficeTypeList?CompanyId=${CompanyId}`;
        return APICall("get", {}, url).then(
            (result) => {
                if (result?.statuscode === 200 || result?.statuscode === 201) {
                    dispatch({
                        type: OFFICE_TYPE,
                        payload: result?.data || [],
                    });
                    return result?.data;
                } else {
                    return Promise.reject();
                }
            },
            (error) => {
                return Promise.reject(error);
            },
        );
    };
};

export const GetRoleList = (mstCustomerId = 0) => {
    return (dispatch) => {
        const url = `/v1/Common/GetRoleList?MST_CUSTOMER_ID=${Number(mstCustomerId) || 0}`;

        return APICall("get", {}, url).then(
            (result) => {
                if (
                    result?.statuscode === 200 ||
                    result?.statuscode === 201
                ) {
                    dispatch({
                        type: ROLE_LIST,
                        payload: result?.data || [],
                    });

                    return result?.data;
                } else {
                    return Promise.reject(result);
                }
            },
            (error) => {
                return Promise.reject(error);
            }
        );
    };
};

export const GetNotesTypeList = (CompanyId) => {
    return (dispatch) => {
        const url = `/v1/Common/GetNotesType?CompanyId=${CompanyId}`;
        return APICall("get", {}, url).then(
            (result) => {
                if (result?.statuscode === 200 || result?.statuscode === 201) {
                    dispatch({
                        type: NOTES_TYPE,
                        payload: result?.data || [],
                    });
                    return result?.data;
                } else {
                    return Promise.reject();
                }
            },
            (error) => {
                return Promise.reject(error);
            },
        );
    };
};

// pendingapi
export const GetProfitCenterList = (CompanyId) => {
    return (dispatch) => {
        const url = `/v1/Common/GetProfitCenterList?CompanyId=${CompanyId}`;
        return APICall("get", {}, url).then(
            (result) => {
                if (result?.statuscode === 200 || result?.statuscode === 201) {
                    dispatch({
                        type: PROFIT_CENTER,
                        payload: result?.data || [],
                    });
                }
            },
            (error) => Promise.reject(error),
        );
    };
};

export const GetPackageTypeList = () => {
    return (dispatch) => {
        const url = `/v1/Common/GetMasterPackageList`;
        return APICall("get", {}, url).then(
            (result) => {
                if (result?.statuscode === 200 || result?.statuscode === 201) {
                    dispatch({
                        type: PACKAGE_TYPE,
                        payload: result?.data || [],
                    });
                }
            },
            (error) => Promise.reject(error),
        );
    };
};

export const GetBlTypeList = (CompanyId = 0) => {
    return (dispatch) => {
        const url = `/v1/Common/GetBLTypesList?CompanyId=${CompanyId}`;
        return APICall("get", {}, url).then(
            (result) => {
                if (result?.statuscode === 200 || result?.statuscode === 201) {
                    dispatch({
                        type: BL_TYPE_LIST,
                        payload: result?.data || [],
                    });

                    return result?.data;
                } else {
                    return Promise.reject();
                }
            },
            (error) => {
                return Promise.reject(error);
            },
        );
    };
};

// Ocean Export
// OES = Ocean Export Shipment
// OER = Ocean Export Rates

// Ocean Import
// OIS = Ocean Import Shipment
// OIR = Ocean Import Rates

// Air Export
// AES = Air Export Shipment
// AER = Air Export Rates

// Air Import
// AIS = Air Import Shipment
// AIR = Air Import Rates
export const GetDocumentTypeList = (ModuleType = 0) => {
    const url = `v1/Common/GetDocumentTypeList?ModuleType=${ModuleType}`;
    return APICall("get", {}, url).then(
        (result) => {
            if (result?.statuscode === 200 || result?.statuscode === 201) {
                return result?.data || [];
            } else {
                return Promise.reject();
            }
        },
        (error) => {
            return Promise.reject(error);
        },
    );
};

/** GET cargo descriptions from HBL for MBL import — BookingId, CompanyId */
export const GetCargoDescFromHBL = (BookingId, CompanyId) => {
    const url = `v1/MBL/GetCargoDescFromHBL?BookingId=${BookingId}&CompanyId=${CompanyId}`;
    return APICall("get", {}, url).then(
        (result) => {
            if (result?.statuscode === 200 || result?.statuscode === 201) {
                return result?.data || [];
            }
            return Promise.reject(result);
        },
        (error) => Promise.reject(error),
    );
};

/** GET cargo descriptions from Dock Receipt for MBL import — BookingId, CompanyId */
export const GetCargoDescFromDockRecipt = (BookingId, CompanyId) => {
    const url = `v1/MBL/GetCargoDescFromDockRecipt?BookingId=${BookingId}&CompanyId=${CompanyId}`;
    return APICall("get", {}, url).then(
        (result) => {
            if (result?.statuscode === 200 || result?.statuscode === 201) {
                return result?.data || [];
            }
            return Promise.reject(result);
        },
        (error) => Promise.reject(error),
    );
};

///api/v1/Common/GetPrintDoc
///payload = OIS, OIR, AES, AER, AIS, AIR
export const GetPrintDoc = (payload) => {
    const url = `/v1/Common/GetPrintDoc?ForModule=${payload}`;
    return APICall("GET", {}, url).then(
        (result) => {
            if (result?.statuscode === 200 || result?.statuscode === 201) {
                return result?.data;
            } else {
                return Promise.reject();
            }
        },
        (error) => {
            return Promise.reject(error);
        },
    );
};

////api/v1/Common/GetColoaderList
// param  Company_Id,Searchtxt = ""
export const GetColoaderList = (Company_Id, Searchtxt = "") => {
    return (dispatch) => {
        const url = `/v1/Common/GetColoaderList?Company_Id=${Company_Id}&Searchtxt=${Searchtxt}`;
        return APICall("get", {}, url).then(
            (result) => {
                if (result?.statuscode === 200 || result?.statuscode === 201) {
                    dispatch({
                        type: CLOADER_LIST,
                        payload: result?.data || [],
                    });
                    return result?.data;
                } else {
                    return Promise.reject();
                }
            },
            (error) => {
                return Promise.reject(error);
            },
        );
    };
};

// Unified entity suggestion API (replaces legacy GetCustomerSuggestion, GetConsigneeSuggestion, etc.)
// GET v1/AutoSuggestion/GetSuggestionFromEntityType?EntityType={type}&Prefix={text}&CompanyId={id}
//
// BookingForm field mapping:
//   Customer / Shipper, Shipper (party)     -> EXPORTER
//   Consignee                               -> CONSIGNEE
//   Forwarder                               -> FORWARDER
//   Notify, Also Notify                     -> NOTIFY
//   Loading Location, ports (routing)       -> TERMINAL
//   Carrier                                 -> OCEAN_CARRIER
//   Vessel                                  -> (legacy GetVesselList — not entity-based)
//   Commodity / HS Codes                    -> (legacy GetCommoditySuggestion / GetHtsusCode)
//   Trucker                                 -> TRUCKER
//   Empty Container Pickup, Container Return-> TOWING
//   Loading Location, Warehouse Name        -> WAREHOUSE
//   Overseas Agent                          -> AGENT
//
// PartiesInformation (Import ISF — aligned with Shipper/Consignee on ImportBookingForm):
//   Supplier / Manufacturer                 -> SUPPLIER
//   Seller, Consolidator (same as Shipper)  -> EXPORTER
//   Stuffer (container stuffing location) -> WAREHOUSE
//   Importer, Ship To (same as Consignee)   -> CONSIGNEE
//   Buyer (ISF beneficial cargo owner)      -> BCO
export const ENTITY_SUGGESTION_TYPES = {
    EXPORTER: "EXPORTER",
    BILLTOPARTY: "BILLTOPARTY",
    FORWARDER: "FORWARDER",
    CONSIGNEE: "CONSIGNEE",
    NOTIFY: "NOTIFY",
    AGENT: "AGENT",
    VENDOR: "VENDOR",
    OCEAN_CARRIER: "OCEAN_CARRIER",
    AIR_CARRIER: "AIR_CARRIER",
    TRUCKER: "TRUCKER",
    TOWING: "TOWING",
    WAREHOUSE: "WAREHOUSE",
    SUPPLIER: "SUPPLIER",
    BROKER: "BROKER",
    BCO: "BCO",
    PROSPECT: "PROSPECT",
    TERMINAL: "TERMINAL",
    OTHER: "OTHER",
};

/** Prefix URL for SearchBar — append search text; SearchBar adds &CompanyId= */
export const getEntitySuggestionSearchAPI = (entityType) =>
    `v1/AutoSuggestion/GetSuggestionFromEntityType?EntityType=${entityType}&Prefix=`;

export const GetSuggestionFromEntityType = (
    EntityType = ENTITY_SUGGESTION_TYPES.EXPORTER,
    Prefix = "",
    CompanyId = 0,
) => {
    return (dispatch) => {
        const url =
            `v1/AutoSuggestion/GetSuggestionFromEntityType?EntityType=${encodeURIComponent(EntityType)}` +
            `&Prefix=${encodeURIComponent(Prefix)}&CompanyId=${CompanyId}`;
        return APICall("get", {}, url).then(
            (result) => {
                if (result?.statuscode === 200 || result?.statuscode === 201) {
                    return result?.data;
                }
                return Promise.reject();
            },
            (error) => Promise.reject(error),
        );
    };
};


// https://api.shipez.ai/api/v1/Common/GetAddressListEntity?AddressId=1&CompanyId=1

/**
 * Fetch address details by AddressId and CompanyId.
 * @param {number|string} addressId - The address ID to search for.
 * @param {number|string} [companyId] - The company ID to provide (optional, default 0).
 * @returns {Promise} Resolves to address details data or rejects on error.
 */
export const GetAddressdetails = (addressId = "", companyId = 0) => {
    const url = `/v1/Common/GetAddressListEntity?AddressId=${encodeURIComponent(addressId)}&CompanyId=${encodeURIComponent(companyId)}`;
    return APICall("get", {}, url).then(
        (result) => {
            if (result?.statuscode === 200 || result?.statuscode === 201) {
                return result?.data;
            }
            return Promise.reject();
        },
        (error) => Promise.reject(error),
    );
};

/**
 * Check whether an address-book entity exists / is valid.
 * GET v1/Common/GetCheckAddressListEntity?AddressId=&CompanyId=
 * @param {number|string} addressId
 * @param {number|string} [companyId]
 * @returns {Promise}
 */
export const GetCheckAddressListEntity = (addressId = "", companyId = 0) => {
    const url = `/v1/Common/GetCheckAddressListEntity?AddressId=${encodeURIComponent(addressId)}&CompanyId=${encodeURIComponent(companyId)}`;
    return APICall("get", {}, url).then(
        (result) => {
            if (result?.statuscode === 200 || result?.statuscode === 201) {
                return result?.data;
            }
            return Promise.reject();
        },
        (error) => Promise.reject(error),
    );
};

/**
 * Check whether a port / place entity exists for the given search value.
 * GET v1/Common/GetPortEntityExist?SearchValue=
 * @param {string} searchValue
 * @returns {Promise}
 */
export const GetPortEntityExist = (searchValue = "") => {
    const url = `/v1/Common/GetPortEntityExist?SearchValue=${encodeURIComponent(searchValue)}`;
    return APICall("get", {}, url).then(
        (result) => {
            if (result?.statuscode === 200 || result?.statuscode === 201) {
                return result?.data;
            }
            return Promise.reject();
        },
        (error) => Promise.reject(error),
    );
};

/**
 * Carriers available for Rate Matrix spot/contract search.
 * GET v1/Common/GetCarrierAvailableForRM?CompanyId=
 * @param {number|string} companyId
 * @returns {Promise<Array<{ carrierName: string, carrierScac: string }>>}
 */
export const GetCarrierAvailableForRM = (companyId) => {
    const url = `/v1/Common/GetCarrierAvailableForRM?CompanyId=${encodeURIComponent(companyId ?? "")}`;
    return APICall("get", {}, url).then(
        (result) => {
            if (result?.statuscode === 200 || result?.statuscode === 201) {
                return Array.isArray(result?.data) ? result.data : [];
            }
            return Promise.reject();
        },
        (error) => Promise.reject(error),
    );
};